import React from "react";
import { BrowserRouter } from "react-router-dom";
import BlockUI from "./BlockUI";
import GrowlMessage from "./components/message/GrowlMessage";
import SecuredRoute from "./components/SecuredRoute";
import Store from "./components/Store";
import ThemeSwitcher from "./components/themeSwitcher/ThemeSwitcher";

export default function App() {
  return (
    <BrowserRouter>
      <ThemeSwitcher>
        <Store>
          <GrowlMessage />
          <SecuredRoute />
          <BlockUI />
        </Store>
      </ThemeSwitcher>
    </BrowserRouter>
  );
}
